import {headingSizes, textSizes} from '@stencil/build-theme/src/build-theme';
import styled, {keyframes} from 'styled-components';

export const CenteredSpaceWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:space-between;
    `,
);

export const CenteredDivWrap = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content:center;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const FlexWrap = styled.div`
  ${textSizes.BaseW2}
  display:flex;
  margin-bottom: 5px;
`;

export const FlexItemCenter = styled.div<{alignitem?: string}>`
  display: flex;
  align-items: ${props => props.alignitem || 'center'};
`;

export const HeaderStyle = styled.h2`
  ${headingSizes.Small};
`;

export const SubHeaderStyle = styled.h3`
  ${textSizes.MediumW3};
  text-transform: capitalize;
  word-break: break-word;
  opacity: ${props => (props.isDateless ? '50%' : '')};
`;

export const SubHeaderStyleSeo = styled.h1(
  props => `
    font-size: ${props.theme.font.custom(16)};
    font-weight:bold;
    text-transform: capitalize;
    word-break: break-word;
    `,
);

export const SmallHeaderStyle = styled.h4`
  ${textSizes.BaseW3}
`;

export const InnerSpacingStyle = styled.div(
  props => `
  background: ${props.theme.colors.ash.dark};
  padding: ${props.noPadding ? props.theme.spacing.custom(0) : props.theme.spacing.custom(8)};
  margin-bottom: ${props.marginBottom};
  `,
);

export const ContainerFixedStyle = styled.div(
  props => `
  background: ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.custom(
    8,
  )} ${props.theme.spacing.custom(8)};
  `,
);

export const CardWrap = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  background: ${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.xlarge};
  margin-bottom:${props.theme.spacing.custom(8)};
  padding: ${props.theme.spacing.custom(12)};
  width: 100%;
  `,
);

export const FooterContainerStyle = styled.div(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.custom(4)};
  position: fixed;
  width: 100%;
  bottom:0;
  box-shadow: 0 .1rem .5rem 0 ${props.theme.colors.shadow.dark};
  `,
);

/*** Shimmer Loader ***/

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }

  100% {
    background-position: 46.8rem 0;
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
  margin-bottom: ${props => props.theme.spacing.small};
  height: 1rem;
`;

export const FlipUpsideDown = styled.div`
  transform: ${props => (props?.isOpen ? 'rotate(180deg)' : '')};
`;

export const CircleBulletForLists = styled.div(
  props => `
  width: ${props.width || '0.5rem'};
  height:  ${props.height || '0.5rem'};
  background:  ${props.color || 'black'};
  border-radius: 50%;
  margin: ${props.margin || '0 0.5rem 0 0'};
`,
);

export const ContentHolder = styled.div(
  props => `
    width: ${props.width || ''};
    height: ${props.height || ''};
    margin: ${props.margin || ''};
    display: ${props.makeFlex ? 'flex' : ''};
    flex: ${props.flexOne ? 1 : ''};
    flex-direction: ${props.column ? 'column' : ''};
    justify-content: ${props.spaceBetween ? 'space-between' : ''};
    align-items: ${props.hrtlCenter ? 'center' : ''};
    text-align: ${props.textRight ? 'right' : ''};
    flex-shrink: ${props.noShrink ? 0 : ''};
  `,
);

export const SectionHeader = styled.h3(
  props => `
    font-weight: bold;
    font-size: ${props.theme.font.custom(22)};
    `,
);

export const HiddenElement = styled.span`
  display: none;
`;

/* Animation Styles Addition */

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

export const slideUp = keyframes`
0% {
  transform: translateY(100%);
}

100% {
  transform: translateY(0%);
}
`;

export const slideDown = keyframes`
0% {
  transform: translateY(0%);
}

100% {
  transform: translateY(100%);
}`;

export const customSlideUpFunc = val => {
  return keyframes`
0% {
  transform: translateY(${val}%);
}

100% {
  transform: translateY(0%);
}
`;
};

export const customSlideDownFunc = val => {
  return keyframes`
0% {
  transform: translateY(0%);
}

100% {
  transform: translateY(${val}%);
}
`;
};

export const slideDownFromTop = keyframes`
0% {
  transform: translateY(-100%);
}
100% {
  transform: translateY(0%);
}
`;

export const slideUpFromTop = keyframes`
0% {
  transform: translateY(0);
}
100% {
  transform: translateY(-100%);
}
`;
